var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

import BaseSelectField from './BaseSelectField';

var MultiSelectField = function MultiSelectField(_ref) {
    var rest = _objectWithoutProperties(_ref, []);

    return React.createElement(BaseSelectField, _extends({}, rest, { multiple: true }));
};

MultiSelectField.propTypes = {
    /** Function will be called with an array of all selected options after user selects a new option */
    onChange: PropTypes.func.isRequired
};
export default MultiSelectField;
import PropTypes from 'prop-types';